import type { ReactNode } from "react";
import { Link } from "react-router";
import { ArrowBackIcon } from "../../shared/ui/icons.tsx";
import styles from "./AuthScreen.module.css";

type AuthScreenProps = {
  title: string;
  subtitle: string;
  /** Ссылка внизу экрана на соседний сценарий: «Нет аккаунта? Зарегистрироваться». */
  footer: { prompt: string; label: string; to: string };
  children: ReactNode;
};

/** Каркас входа и регистрации: стрелка на Start, заголовок, форма и ссылка на соседний экран внизу. */
export function AuthScreen({ title, subtitle, footer, children }: AuthScreenProps) {
  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <Link to="/" className={styles.back} aria-label="Назад">
          <ArrowBackIcon />
        </Link>
        <div className={styles.headings}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </header>
      <div className={styles.content}>
        {children}
        <p className={styles.footer}>
          {footer.prompt}{" "}
          <Link to={footer.to} className={styles.footerLink}>
            {footer.label}
          </Link>
        </p>
      </div>
    </main>
  );
}
